import { Action, Dispatch } from 'redux'
import { setConfirmPasswordErrorAction } from 'reducks/error/actions'

const isValidConfirmPassword = (password: string, confirmPassword: string) => {
  return async (dispatch: Dispatch<Action>) => {
    if (password === confirmPassword) {
      dispatch(setConfirmPasswordErrorAction(''))
    } else {
      dispatch(setConfirmPasswordErrorAction('確認用パスワードが一致していません。'))
    }
  }
}

export default isValidConfirmPassword
